import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

export const useGetClocksErrors = (
  fromVersion?: number | null,
  toVersion?: number | null,
) => {
  return useQuery({
    queryKey: ["clocksErrors", fromVersion, toVersion],
    queryFn: () =>
      adminApiClient
        .getClocksErrors({ fromVersion, toVersion })
        .then((res) => res.data),
    enabled: fromVersion != null || toVersion != null,
  });
};
